<template>
    <div class="modal" tabindex="-1" role="dialog" ref="modal">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header" v-if="$slots.title">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <h5 class="modal-title"><slot name="title"></slot></h5>
                </div>
                <div class="modal-body">
                    <slot name="body"></slot>
                </div>
                <div class="modal-footer" v-if="$slots.footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { $ } from '../assets/vendor';
export default {
    name: 'Modal',
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    mounted() {
        $(this.$refs.modal).on('hidden.bs.modal', () => {
            this.$emit('hidden');
        });
        $(this.$refs.modal).on('show.bs.modal', () => {
            this.$emit('show');
        });
    },
    watch: {
        show(isOpen) {
            $(this.$refs.modal).modal(isOpen ? 'show' : 'hide');
        }
    }
};
</script>
